/**
 * Volunteer-portal API + auth helpers.
 * Volunteers have a separate JWT (stored under hw_vol_access_token) so they
 * never collide with staff/care-seeker sessions in the same browser.
 */
import axios from "axios";

const TOKEN_KEY = "hw_vol_access_token";
const VOL_KEY = "hw_vol_profile";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const volApi = axios.create({
  baseURL: API,
});

volApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

volApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(VOL_KEY);
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/volunteer/login")) {
        window.location.href = "/volunteer/login?expired=1";
      }
    }
    return Promise.reject(err);
  },
);

export const storeVolSession = (token, profile) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(VOL_KEY, JSON.stringify(profile));
};

export const getStoredVolProfile = () => {
  try {
    return JSON.parse(localStorage.getItem(VOL_KEY) || "null");
  } catch {
    return null;
  }
};

export const clearVolSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(VOL_KEY);
};

export const isVolLoggedIn = () => !!localStorage.getItem(TOKEN_KEY);

export const formatVolError = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg || JSON.stringify(d)).join(", ");
  }
  return err?.message || "Something went wrong";
};
